define('home/collections/PaginatedUserCollection',[
    'core/collections/PaginatedCollection',
    'core/UniqueModel',

    'home/models/User',
], function (
    PaginatedCollection,
    UniqueModel,

    User
) {
    'use strict';

    var PaginatedUserCollection = PaginatedCollection.extend({
        model: UniqueModel.boundModel(User),

        initialize: function (_models, options) {
            if (options && options.url)
                this.url = options.url;
        },
    });

    return PaginatedUserCollection;
});

